var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZonguruMiniLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 34,
    viewBox: "0 0 44 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4175 20.5066C15.3455 21.3821 12.5884 23.1176 10.4714 25.5082C8.35451 27.8988 6.9662 30.8447 6.47037 33.9982C5.89231 33.4791 5.34418 32.9277 4.82863 32.3465C1.80702 28.9393 0 24.6116 0 19.9034C0 8.90784 9.84298 2.90524e-05 22 2.90524e-05C25.2441 -0.00889122 28.4559 0.644729 31.4381 1.92078C31.6154 2.83806 31.7044 3.77022 31.7037 4.70447C31.7037 12.1035 26.1229 18.3724 18.4175 20.5066Z",
    fill: "#F04B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7036 4.69704C31.7011 7.22848 31.0462 9.7166 29.8019 11.9216C25.4976 14.8246 20.4216 16.372 15.2287 16.3644C10.4055 16.3729 5.67515 15.0395 1.56738 12.5136C4.81 5.18141 12.7364 2.90524e-05 21.9999 2.90524e-05C25.2441 -0.00889122 28.4558 0.644728 31.4381 1.92078C31.6149 2.83563 31.7038 3.76528 31.7036 4.69704Z",
    fill: "#F89521"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.4381 1.92078C28.1379 5.92929 23.4003 8.97279 17.8808 10.5057C13.9191 11.6351 10.3272 13.7926 7.47035 16.7589C4.6135 19.7251 2.59352 23.3942 1.61574 27.3934C0.552127 25.0393 0.00138055 22.4863 0 19.9034C0 8.90784 9.84299 2.90524e-05 22 2.90524e-05C25.2441 -0.00889122 28.4559 0.644728 31.4381 1.92078Z",
    fill: "#E83E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2227 7.97994C33.5717 6.31653 33.6525 4.60809 33.4622 2.91919C38.2407 5.5637 41.8195 9.81161 43.2774 14.8371C40.4099 11.9127 36.993 9.58244 33.2227 7.97994Z",
    fill: "#5FC4BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7216 23.0731C43.3244 25.304 42.5198 27.4428 41.3482 29.3828C40.2905 26.4317 38.6022 23.7463 36.4008 21.5131C34.1994 19.28 31.5376 17.5528 28.6006 16.4516C29.7789 15.2496 30.7845 13.8899 31.5888 12.4116C36.6447 14.6174 40.886 18.3444 43.7216 23.0731Z",
    fill: "#1E8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9998 19.9034C44.0005 20.9661 43.9072 22.0268 43.7212 23.0731C40.8856 18.3444 36.6443 14.6174 31.5884 12.4116C32.3437 11.0206 32.8942 9.52802 33.2227 7.97992C36.9904 9.58085 40.4053 11.9085 43.2718 14.8297C43.7538 16.4779 43.9989 18.1862 43.9998 19.9034Z",
    fill: "#36A99B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3482 29.381C40.7164 30.436 39.9877 31.4301 39.1716 32.3502C38.6565 32.933 38.1084 33.4857 37.5299 34.0056C36.9877 30.538 35.3671 27.329 32.8978 24.8332C30.4285 22.3374 27.2357 20.6815 23.772 20.1001C25.5529 19.1287 27.18 17.8992 28.6006 16.4517C31.5374 17.5526 34.1991 19.2796 36.4005 21.5123C38.6019 23.7451 40.2903 26.4302 41.3482 29.381Z",
    fill: "#02584F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3544 5.97569C16.8489 5.98198 13.4265 4.90962 10.5522 2.90435C13.7351 1.18066 17.2663 0.197016 20.8826 0.0267156C24.4988 -0.143585 28.1069 0.503854 31.4379 1.92078C28.3423 4.54443 24.4135 5.9818 20.3544 5.97569Z",
    fill: "#FDBA13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonguruMiniLogo);
export default __webpack_public_path__ + "static/media/zonguru-mini-logo.671f4814a665d6380c8d2c851b2f1448.svg";
export { ForwardRef as ReactComponent };